import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorName } from '@panaya/ui/styles-to-code';
import { IconName, IconSize } from '@panaya/ui/p-icon';
import { ButtonTypeEnum } from './button-type.enum';
import { DefaultTo } from '@panaya/utils';

@Component({
    selector: 'p-button',
    template: `
        <button
            class="p-btn"
            [attr.automation-id]="automationId"
            [ngClass]="classes"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel"
            (click)="onClick($event)"
        >
            <p-icon
                *ngIf="iconBefore"
                class="p-btn-icon-pre"
                [name]="iconBefore"
                [size]="iconBeforeSize"
                [color]="iconBeforeColor"
                [disabled]="disabled"
            ></p-icon>
            <span class="p-btn-label p-paragraph-1 p-tpgr-medium" *ngIf="label">{{ isSentenceCase ? (label | sentenceCase) : label }}</span>
            <p-icon
                *ngIf="iconAfter"
                class="p-btn-icon-post"
                [name]="iconAfter"
                [size]="iconAfterSize"
                [color]="iconAfterColor"
                [disabled]="disabled"
            ></p-icon>
        </button>
    `,
    styleUrls: ['./p-button.component.scss']
})
export class PButtonComponent {
    @Input() label = '';
    @Input() ariaLabel = '';
    @Input() large = false;
    @Input() @DefaultTo(false) public disabled!: boolean;
    @Input() iconBefore?: IconName;
    @Input() iconBeforeSize!: IconSize;
    @Input() iconBeforeColor!: ColorName;
    @Input() iconAfter?: IconName;
    @Input() iconAfterSize!: IconSize;
    @Input() iconAfterColor!: ColorName;
    @Input() buttonType: string = ButtonTypeEnum.Primary;
    @Input() isSentenceCase = true;

    @Output() buttonClicked: EventEmitter<Event> = new EventEmitter();

    public get classes(): string[] {
        const classParams = [];
        this.iconBefore ? classParams.push('p-btn-icon-before') : null;
        this.iconAfter ? classParams.push('p-btn-icon-after') : null;
        classParams.push(`p-btn-${this.buttonType}`);
        if (this.buttonType !== ButtonTypeEnum.IsIcon) {
            this.large ? classParams.push('p-btn-large') : classParams.push('p-btn-small');
        }
        return classParams;
    }

    protected onClick(event: Event): void {
        if (!this.disabled) {
            this.buttonClicked.emit(event);
        }
    }

    get automationId(): string {
        const genericIdentifier = 'p-button';
        const separator = '_';
        const unique = this.label || this.iconBefore || this.iconAfter;
        return unique ? genericIdentifier + separator + unique : genericIdentifier;
    }
}
